import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppExcelUploadView from '../../../components/AppExcelUploadView';
import { remoteAttendanceApi } from './api/remoteAttendanceApi';
import { appToast } from '../../../components/AppToast';

export default function RemoteAttendanceBulkUploadScreen() {
  const navigate = useNavigate();

  const handleDownloadSample = async () => {
    try {
      await remoteAttendanceApi.downloadTemplate();
      appToast.success('Remote Attendance template downloaded successfully.');
    } catch (err) {
      console.error(err);
      appToast.error('Failed to download template.');
    }
  };

  const handleUpload = async (file) => {
    try {
      const result = await remoteAttendanceApi.uploadBulk(file);
      if (result.failed_count > 0 && result.imported_count === 0) {
        const firstErr = result.errors?.[0] || 'Bulk upload failed.';
        appToast.error(firstErr);
        throw new Error(firstErr);
      } else if (result.failed_count > 0) {
        appToast.warning(
          `Imported ${result.imported_count} records with ${result.failed_count} errors. Check console or list for details.`
        );
      } else {
        appToast.success(result.message || 'All remote attendance logs imported successfully!');
      }
      navigate('/payroll/remote-attandance');
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || 'Failed to upload remote attendance spreadsheet.';
      appToast.error(detail);
      throw err;
    }
  };

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-16">
      {/* ── Page Header Canopy ── */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Remote Attendance
          </p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            Bulk Upload Remote Attendance Logs
          </h1>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            Import verified employee remote check-in logs via standardized Excel spreadsheet.
          </p>
        </div>
      </section>

      {/* ── Shared 3-Step Excel Importer ── */}
      <AppExcelUploadView
        title="Upload Remote Attendance Logs"
        subtitle="Bulk import employee remote attendance check-ins using Excel."
        description="Use this option to upload remote attendance check-ins using Excel sheets in 3 simple steps. Download the sample template, fill in the details, and upload the file. Please make sure that all Employee ID Card numbers and Reasons match the master data."
        sampleFileName="Remote_Attendance_Template.xlsx"
        onDownloadSample={handleDownloadSample}
        onUpload={handleUpload}
        cancelPath="/payroll/remote-attandance"
        backLabel="Back to Remote Attendance List"
        masterRequirements={[
          'Name (Employee Name or ID Card No)',
          'Date (YYYY-MM-DD)',
          'Intime (HH:MM 24hr format)',
          'OutTime (HH:MM 24hr format)',
          'Reason (e.g. Work From Home / Remote, On Duty / Outdoor Client Visit, Other)',
          'Remarks (Mandatory if Reason is Other)',
        ]}
      />
    </div>
  );
}
